import React, { Component } from 'react'

export default class Logout extends Component {
    componentDidMount = () => {
        localStorage.clear()
        window.location.replace('/')
    }
    render() {
        return (
            <div>
                <svg id="darkLoader" className="" width="100%" viewBox="0 0 100 100" style={{ backgroundColor: 'white' }}>
                    <circle className="circle" id="circle-1" cx={50} cy={50} r={1000} fill="rgba(167, 206, 232, .25)" />
                    <circle className="circle" id="circle-2" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
                    <circle className="circle" id="circle-3" cx={50} cy={50} r={10} fill="rgba(167, 206, 232, .25)" />
                </svg>
            </div>
        )
    }
}
